import { render, staticRenderFns } from "./AccountCompanyAuth.vue?vue&type=template&id=0c802054&scoped=true"
import script from "./AccountCompanyAuth.vue?vue&type=script&lang=js"
export * from "./AccountCompanyAuth.vue?vue&type=script&lang=js"
import style0 from "./AccountCompanyAuth.vue?vue&type=style&index=0&id=0c802054&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c802054",
  null
  
)

export default component.exports